import React from "react";
import { StoreState } from "../../models/states/StoreState";
import { connect, DispatchProp } from "react-redux";
import { getRecall } from "../../redux/reducers/recallReducer";
import { RecallType } from "../../piping/RecallType";
import { recallText } from "../../redux/actions";

interface Props {
    text: string;
    type?: RecallType;
    render?(recalled: string): React.ReactNode;
}

interface StateProps {
    recalled: string;
}

type PropsU = Props & StateProps & DispatchProp;

class RecalledTextImpl extends React.Component<PropsU, {}> {
    shouldComponentUpdate(nextProps: PropsU) {
        // Don't compare render function as it is always a new instance.
        return this.props.text !== nextProps.text || this.props.recalled !== nextProps.recalled;
    }

    compareRender(
        a: (recalled: string) => React.ReactNode,
        b: (recalled: string) => React.ReactNode,
    ) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        return a.toString() === b.toString();
    }

    componentDidMount() {
        this.evaluateRecall(this.props);
    }

    componentDidUpdate() {
        this.evaluateRecall(this.props);
    }

    evaluateRecall(props: PropsU) {
        if (props.text == null || props.recalled != null) return;
        props.dispatch(recallText(props.text, props.type));
    }

    defaultRender(recalled: string) {
        return <span dangerouslySetInnerHTML={{ __html: recalled }} />;
    }

    render() {
        let recalledText = this.props.recalled;
        if (recalledText == null) recalledText = this.props.text;
        return (this.props.render || this.defaultRender)(recalledText);
    }
}

const mapStateToProps = (state: StoreState, props: Props): StateProps => ({
    recalled: getRecall(state.recall, props.text, props.type),
});

export const RecalledText = connect(mapStateToProps)(RecalledTextImpl);
